import { getProjectChatBotConnectors } from '@/utils/subscribersGrowthWidget'

const TEMPLATE_KEYS = [
    'returnability:view',
    'gcb2:tasklist:view',
    'marketingReport:view',
    'gcb2:activation:edit',
]

const VIEW_KEY = 'gcb2:subscribersGrowth:view'
const EDIT_KEY = 'gcb2:subscribersGrowth:edit'

/** Модуль включён для проекта (учёт boolean и строк с бэка). */
export function isPermissionActive(perm) {
    if (!perm) return false
    const v = perm.isActive
    return v === true || v === 1 || v === 'true' || v === '1'
}

function upsertSubscribersGrowthPermission(rs, key, perm) {
    const next = JSON.parse(JSON.stringify(perm))
    next.isActive = true
    const existing = rs[key]
    if (!existing || !isPermissionActive(existing)) {
        rs[key] = next
    }
}

export function mergeSubscribersGrowthRoleDefaults(project) {
    const rs = project && project.rolesSettings
    if (!rs || typeof rs !== 'object') return
    if (getProjectChatBotConnectors(project.connectors || []).length === 0) return

    const templateKey = TEMPLATE_KEYS.find(
        (k) => rs[k] && rs[k].access && typeof rs[k].access === 'object' && isPermissionActive(rs[k])
    )
    if (!templateKey) return

    const tmpl = rs[templateKey]
    const roleIds = Object.keys(tmpl.access)
    if (!roleIds.length) return

    const allView = {
        isActive: true,
        access: Object.fromEntries(roleIds.map((rid) => [rid, true])),
    }
    const editAccess = Object.fromEntries(
        roleIds.map((rid) => [rid, (rid === 'observer' ? false : true)])
    )
    const editPerm = {
        isActive: true,
        access: editAccess,
    }

    upsertSubscribersGrowthPermission(rs, VIEW_KEY, allView)
    upsertSubscribersGrowthPermission(rs, EDIT_KEY, editPerm)
}
